import { PlusIcon } from '@phosphor-icons/react';

import { Button } from '@/components/common/button';
import { ExportMenu } from '@/components/common/export-menu';
import { FilterButton } from '@/components/common/filter-button';
import { SearchBar } from '@/components/common/search-bar';

import { useModuleHeaderConfig } from './module-header-context';
import styles from './page-header.module.scss';

export function PageHeader() {
  const config = useModuleHeaderConfig();
  if (!config) return null;

  const { title, search, filter, export: exportCfg, primaryAction } = config;

  return (
    <header className={styles.header}>
      <h1 className={styles.title}>{title}</h1>
      <div className={styles.toolbar}>
        {search ? <SearchBar placeholder={search.placeholder} onSearch={search.onSearch} /> : null}
        {filter ? (
          <FilterButton active={filter.active} onClick={filter.onClick} onClear={filter.onClear} />
        ) : null}
        {exportCfg ? (
          <ExportMenu
            endpoint={exportCfg.endpoint}
            params={exportCfg.params}
            filename={exportCfg.filename}
          />
        ) : null}
        {primaryAction ? (
          <Button variant="neutral" onClick={primaryAction.onClick} startIcon={<PlusIcon />}>
            {primaryAction.label}
          </Button>
        ) : null}
      </div>
    </header>
  );
}
